import { render, staticRenderFns } from "./BulkDeleteBar.vue?vue&type=template&id=596bf298"
import script from "./BulkDeleteBar.vue?vue&type=script&lang=js"
export * from "./BulkDeleteBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports